import api from './index.js';

export const videoApi = {
  /**
   * Upload a video file for analysis.
   * @param {FormData} formData - must include: video (File), athlete_id, event, device_id
   * @param {function} onProgress - (pct: number) => void
   */
  upload: (formData, onProgress) =>
    api.post('/api/upload_video', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300_000, // 5 min for large uploads
      onUploadProgress: (e) => {
        if (onProgress && e.total) {
          onProgress(Math.round((e.loaded * 100) / e.total));
        }
      },
    }).then(r => r.data),

  // All video CRUD served by routes/v1/video.js (mounted at /api/v1/video)
  getStatus: (videoId) =>
    api.get(`/api/v1/video/${videoId}/status`).then(r => r.data),

  listForAthlete: (athleteId, params = {}) =>
    api.get(`/api/v1/video/athlete/${athleteId}`, { params }).then(r => r.data),

  delete: (videoId) =>
    api.delete(`/api/v1/video/${videoId}`).then(r => r.data),

  getTags: (videoId) =>
    api.get(`/api/v1/video/${videoId}/tags`).then(r => r.data),

  addTag: (videoId, tag) =>
    api.post(`/api/v1/video/${videoId}/tags`, tag).then(r => r.data),

  getAnnotations: (videoId) =>
    api.get(`/api/v1/video/${videoId}/annotations`).then(r => r.data),

  saveAnnotation: (videoId, annotation) =>
    api.post(`/api/v1/video/${videoId}/annotations`, annotation).then(r => r.data),

  // Landings still served by server.js at /athletes/:id/landings
  getLandingDetails: (athleteId) =>
    api.get(`/athletes/${athleteId}/landings`).then(r => r.data),

  // Coach feedback (video → athlete loop)
  getVideoFeedback: (videoId) =>
    api.get(`/api/v1/video/${videoId}/feedback`).then(r => r.data),

  addVideoFeedback: (videoId, body) =>
    api.post(`/api/v1/video/${videoId}/feedback`, body).then(r => r.data),

  getAthleteFeedback: (athleteId) =>
    api.get(`/api/v1/video/feedback/athlete/${athleteId}`).then(r => r.data),

  acknowledgeFeedback: (feedbackId) =>
    api.post(`/api/v1/video/feedback/${feedbackId}/acknowledge`).then(r => r.data),
};

export default videoApi;
